import React from 'react';
import { Col, Row, Card } from 'antd';
import { withTranslation } from 'react-i18next';

class MobileDataInformationCard extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { t } = this.props;
    return (
      <Card
        title={<span style={{ marginLeft: '45%' }}>{t('label_mobile')}</span>}
        bordered={true}
      >
        <Row style={{ marginLeft: '50px' }}>
          <Col span={8}>
            <Card style={{ width: 200, height: 200, textAlign: 'center' }}>
              <h3>{t('label_signalStrength')}</h3>
              <br />
              <br />
              <h4 style={{ fontSize: 18 }}>{this.props.signalStrength}</h4>
            </Card>
          </Col>
          <Col span={8}>
            <Card style={{ width: 200, height: 200, textAlign: 'center' }}>
              <h3>{t('label_dailyMobileData')}</h3>
              <br />
              <br />
              <h4 style={{ fontSize: 18 }}>
                {(parseFloat(this.props.dailyMobileData) / 1000000000).toFixed(
                  2,
                )}{' '}
                GB
              </h4>
            </Card>
          </Col>
          <Col span={8}>
            <Card style={{ width: 200, height: 200, textAlign: 'center' }}>
              <h3>{t('label_hourlyMobileData')}</h3>
              <br />
              <br />
              <h4 style={{ fontSize: 18 }}>
                {(parseFloat(this.props.hourlyMobileData) / 1000000000).toFixed(
                  2,
                )}{' '}
                GB
              </h4>
            </Card>
          </Col>
        </Row>
      </Card>
    );
  }
}

export default withTranslation()(MobileDataInformationCard);
